<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <div class="main_conainer mobile" :style="{'padding-top': setPadd}">
          <div class="main-header">
            <img class="main-logo" :src="navLogo" />
            <h4 class="mt15 col_secondary fw400 fs24" v-html="setTitle"></h4>
          </div>
          <div class="main-body mt30">
            <slot name="form"></slot>  
          </div>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: ['title', 'padTop'],
  name: 'Layout2',
  data () {
    return {
      navLogo: '',
      favicon: '',
      cloudName: '',
    }
  },
  computed: {
    setTitle () {
      const title = this.title.replace('<cloudName>', `<span class="fwbolder text-transform-none">${this.cloudName}</span>`)
        return `<span class="col_grey95">${title}</span>`
    },
    setPadd () {
      return this.padTop? this.padTop : 0
    }
  },
  methods: {
    getImage (name, varName) {
      this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: name }).then(res => {
        if (res && typeof res === 'string') {
          this[varName] = 'data:image/png;base64,' + res
        }
      })
    },
    getProfileDetails () {
      this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
        if (res) {
          let titleElement = document.getElementById('cloudTitle')
          titleElement.innerHTML = res.name
          this.cloudName = res.name
        }
      })
    },
  },
  watch: {
    favicon () {
      if (this.favicon) {
        let faviconElement = document.getElementById('favicon')
        faviconElement.href = this.favicon
      }
    }
  },
  created () {
    this.getProfileDetails()
    this.getImage('logo-main.png', 'navLogo')
    this.getImage('favicon.png', 'favicon')
  }
}
</script>

<style>
  
</style>

